module.exports = __webpack_public_path__ + "img/figure-13.c223e7a2.png";